// returns cost based on totalArea in ££
export const calculateCost = (totalArea: number): number => {
  if (totalArea <= 0) return 0;
  if (totalArea <= 1) return 30;
  if (totalArea <= 30) return 29 + (totalArea - 1) * 15;
  return 30 + 29 * 15 + (totalArea - 30) * 15;
};

export const calculateHestiCost = (totalArea: number): number => {
  if (totalArea <= 0) return 0;
  if (totalArea <= 1) return 8;
  return 8 * totalArea;
};
